import React from 'react'
import { base } from 'lib/styleguide/base.scss'
import styles from './Popover.scss'
import { Overlay } from 'react-overlays'
import cx from 'classnames'
import { IntlProvider } from 'react-intl'

export const Popover = ({
  target,
  container,
  containerPadding,
  placement,
  children,
  intl,
  noPadding,
  maxWidth,
  onRequestClose
}) => {
  return (
    <Overlay
      show
      rootClose
      offset={[0, 10]}
      onHide={onRequestClose}
      placement={placement}
      container={container}
      containerPadding={containerPadding}
      target={target}
    >
      {(props) => {
        return <PopoverContents noPadding={noPadding} container={container} target={target} maxWidth={maxWidth} {...props}>
          {intl // Overlay breaks our intl context, so we have to recreate it
            ? <IntlProvider {...intl}>
              {children}
            </IntlProvider>
            : <>
              {children}
            </>
          }
        </PopoverContents>
      }}
    </Overlay>
  )
}

Popover.defaultProps = {
  containerPadding: 5
}

export const PopoverContents = ({
  props,
  maxWidth,
  placement,
  children,
  noPadding,
  noArrow,
  arrowProps
}) => {
  const cn = cx(
    base,
    styles.Popover,
    styles['placement-' + placement],
    noPadding && styles.noPadding
  )

  return (
    <div {...props} style={{ ...props.style, maxWidth }} className={cn} >
      {!noArrow && <div className={styles.arrow} {...arrowProps} placement={placement} style={arrowProps.style} />}
      {children}
    </div>
  )
}
